import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, catchError, retry, throwError } from 'rxjs';

@Injectable()
export class ErrorCatchingInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((response: HttpErrorResponse) => {
        // Asl xatoni qaytaramiz — NSwag va boshqa clientlar HttpErrorResponse
        // orqali response body ni o‘qib, to‘g‘ri xabar (masalan SwaggerException.response) beradi.
        return throwError(() => response);
      })
    );
  }
}
